import React, { useEffect, useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';

import { Method, Service } from 'shared-components/configuration';
import useSWQuery from 'shared-components/hooks/useSWQuery';
import { useSWCallbackPaymentEvent } from 'shared-components/providers/SWEventProvider';
import { RFQ_QUERY } from 'shared-components/queries/graphql';
import { convertUTCtoCET } from 'shared-components/utils';
import { PendingPaymentType } from 'types/grapql';

const LiveOperations = () => {
  const columns: TableColumn<PendingPaymentType>[] = [
    {
      name: 'ID',
      cell: (row) => {
        if (row.id) {
          return atob(row.id).split(':').at(1) || '';
        }
        return '';
      },
      wrap: true,
      width: '80px'
    },
    {
      name: 'TX ref',
      selector: (row) => row.txRef ?? '',
      wrap: true
    },
    {
      name: 'Company name',
      selector: (row) => {
        return row.merchantName;
      },
      wrap: true,
      minWidth: '150px'
    },
    {
      name: 'Status',
      selector: (row) => row.status ?? '',
      wrap: false,
      minWidth: '150px'
    },
    {
      name: 'KYC fee',
      selector: (row) => row.kycFee,
      wrap: true,
      width: '93px'
    },
    {
      name: 'SEK deposit',
      selector: (row) => row.sekDeposit.toFixed(2) ?? '', //TODO: replace by eurRequest
      wrap: true,
      width: '120px'
    },
    {
      name: 'Created at',
      selector: (row) => convertUTCtoCET(row.createdAt) ?? '',
      width: '180px'
    },
    {
      name: 'Settled at',
      selector: (row) => convertUTCtoCET(row.settledAt) ?? '',
      width: '180px'
    }
  ];

  const [rfqList, setRfqList] = useState<any>([]);

  const rfqs = useSWQuery({
    service: Service.GRAPHQL,
    method: Method.QUERY,
    returnObjectName: 'rfqLive',
    data: {
      query: RFQ_QUERY('rfqLive'),
      variables: {
        first: 100
      }
    },
    auto: false,
    onResponse: (data: any) => {
      const rfq = {
        data: data?.edges?.map((value: any) => {
          const current = value.node;
          try {
            current.kycData = JSON.parse(current.kycData);
          } catch {
            // error handling if needed
          }
          return current;
        }),
        pageInfo: data?.pageInfo,
        totalCount: data.totalCount
      };

      setRfqList((prevRfq: any) => {
        // Copy previous data array if available
        const updatedData = prevRfq?.data ? [...prevRfq.data] : [];
        let updatedTotalCount = prevRfq?.totalCount || 0;

        // Loop through each new record in rfq.data
        for (const record of rfq.data) {
          const index = updatedData.findIndex((item) => item.id === record.id);

          // If the record status is not RUNNING, remove it if present.
          if (record.status === 'RUNNING') {
            // If status is RUNNING, either replace the existing record or add it.
            if (index === -1) {
              updatedData.unshift(record);
              updatedTotalCount++;
            } else {
              updatedData[index] = record;
            }
          } else {
            if (index !== -1) {
              updatedData.splice(index, 1);
              updatedTotalCount--;
            }
          }
        }

        // Sort the records by createdAt in descending order (newest first)
        updatedData.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

        return {
          data: updatedData,
          pageInfo: rfq.pageInfo,
          totalCount: updatedTotalCount
        };
      });
    }
  });

  useSWCallbackPaymentEvent((data: any) => {
    const existingRecord = rfqList?.data?.find((record: any) => record.operationId === data.operation_id);
    if (existingRecord && existingRecord.status === data.status) {
      console.log('STATUS IS THE SAME. IGNORING');
      return;
    }
    setTimeout(() => {
      rfqs.execute({ variables: { operationId: data.operation_id } });
    }, 2000);
  });
  useEffect(() => {
    rfqs.execute({ variables: { status: 'RUNNING' } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DataTable
      title={'Live deposits'}
      highlightOnHover={true}
      columns={columns}
      data={rfqList.data ?? []}
      //      progressPending={loading}
      //      pagination
      //      paginationServer
      //      paginationPerPage={30}
      //      paginationTotalRows={totalRows}
      //      onChangeRowsPerPage={handlePerRowsChange}
      //      onChangePage={handlePageChange}
      customStyles={{
        headCells: {
          style: {
            backgroundColor: 'lightgray',
            textTransform: 'uppercase'
          }
        }
      }}
      className={'shadow p-3 mb-5 bg-white overflow-auto'}
      //expandOnRowClicked
      //expandableRows
      //expandableRowsComponent={ExpandedComponent}
      //expandableInheritConditionalStyles
    />
  );
};

export default LiveOperations;
